import { isFeedbackCategory, isRating } from '@feedback-service/shared';
import { useMemo } from 'react';

import { useFeedbackUrlParams } from './useFeedbackUrlParams';

import { isValidAppId } from '@/lib/appId';
import type { FeedbackFormData } from '@/types/feedback';

type PrefillData = Partial<FeedbackFormData>;

export function useFeedbackPrefill(): PrefillData {
  const { prefill, appId: urlAppId } = useFeedbackUrlParams();

  return useMemo(() => {
    const result: PrefillData = {};

    if (urlAppId && isValidAppId(urlAppId)) {
      result.appId = urlAppId;
    }

    if (!prefill) {
      return result;
    }

    try {
      const decoded = decodeURIComponent(prefill);
      const parsed = JSON.parse(decoded);

      if (typeof parsed.description === 'string') {
        result.description = parsed.description;
      }

      if (isFeedbackCategory(parsed.category)) {
        result.category = parsed.category;
      }

      if (parsed.appId && isValidAppId(parsed.appId)) {
        result.appId = parsed.appId;
      }

      if (isRating(parsed.rating)) {
        result.rating = parsed.rating;
      }

      if (typeof parsed.userEmail === 'string') {
        result.userEmail = parsed.userEmail;
      }

      if (typeof parsed.userName === 'string') {
        result.userName = parsed.userName;
      }

      return result;
    } catch {
      try {
        const decoded = decodeURIComponent(prefill);
        if (typeof decoded === 'string') {
          result.description = decoded;
        }
      } catch {
        return result;
      }
      return result;
    }
  }, [prefill, urlAppId]);
}
